export const SHOPIFY = 'shopify'
export const MAGENTO = 'magento'
export const WOOCOMMERCE = 'woocommerce'
export const VTEX = 'vtex'
